import { render, staticRenderFns } from "./Password1.vue?vue&type=template&id=46d06b72&scoped=true"
import script from "./Password1.vue?vue&type=script&lang=js"
export * from "./Password1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d06b72",
  null
  
)

export default component.exports